import moment from 'moment';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { store } from '../../../store';
import { api } from '../../api';

type IRankingIndex = Array<{
  id: number,
  from: string,
  to: string,
}>

type IRanking = Array<{
  user: {
    nickname: string,
    gravatar_url?: string,
  },
  count: number,
}>

@Component
export default class extends Vue {
  gravatarSize = 96
  ranking: null | IRanking = null
  rankings: IRankingIndex = []
  period = 'dayly'
  ranking_id: null | number | string = null

  async refreshRankings() {
    const axios = api.default
    const { data } = await axios.get('../api/v1/rankings', {
      params: { period: this.period },
    })
    this.rankings = data
    switch (this.period) {
      case 'monthly':
        this.ranking_id = data.length > 0 ? data[0].id : null
        break
      case 'hourly':
        this.ranking_id = 'recent-1h'
        break
      case 'dayly':
        this.ranking_id = 'recent-24h'
        break
      case 'weekly':
        this.ranking_id = 'recent-1week'
        break
    }
  }

  @Watch('ranking_id')
  async onRankingIdChange() {
    if (this.ranking_id !== null) {
      const axios = api.default
      const { data } = await axios.get(`../api/v1/rankings/${this.ranking_id}`)
      this.ranking = data
    } else {
      this.ranking = null
    }
  }

  @Watch('period', { immediate: true })
  async onPeriodChange() {
    return await this.refreshRankings()
  }

  onClose() {
    this.$router.back()
  }

  get maxCount() {
    if (this.ranking) {
      return Math.max(...this.ranking.map((r) => r.count))
    }
  }

  formatDate(s: string) {
    return moment(s).format('lll')
    // switch (this.period) {
    //   case 'hourly':
    //     return moment(s).format('LT')
    //   case 'dayly':
    //     return moment(s).format('l')
    //   case 'monthly':
    //     return moment(s).format('l')
    // }
  }

  get user() {
    const session = store.galaxyCruise.session
    if (session) {
      return session.user
    }
  }
}
